import * as S from './styled'
import Icon from './Icon'

const Button = ({ text, ...props }) => (
  <S.Button {...props} >
    <Icon />
    {text}
  </S.Button>
)

export default Button
